export default "__VITE_ASSET___R6cvRaY__"